import {DummyStorySlug} from './stores/activeDummyStory';
import {ActiveStoryObjectModel} from './stores/activeStoryObject';
import {ActiveDummyStorySlugModel} from './stores/activeDummyStory';
import {Storyboard} from '@/entities/storyboard';
import {Story} from '@/entities/story';

export interface StoryboardStoreState {
    activeDummyStory: ActiveDummyStorySlugModel;
    activeStoryObject: ActiveStoryObjectModel;
    activeStoryboard: {
        activeStoryboard: Storyboard | null;
        activeId: number | null;
    };
    storyboards: {
        items: Storyboard[];
        loading: boolean;
    };
}

export interface StoryObjectContext {
    activeDummyStorySlug: DummyStorySlug | '';
    activeStoryObject: string;
    storyboard: Storyboard | null;
}

export type StoryObjectType = 'agent_id' | 'team_id' | 'customer_id';

export const STORY_OBJECT_TYPE_MAP: Record<DummyStorySlug, StoryObjectType> = {
    [DummyStorySlug.Agents]: 'agent_id',
    [DummyStorySlug.Teams]: 'team_id',
    [DummyStorySlug.Customers]: 'customer_id',
} as const;

export interface StoryObjectDetails {
    id: string;
    name: string;
    externalId?: string;
}

export interface StoryboardViewProps {
    activeStoryboardHashid: string;
    activeStoryUrl: string;
    activeStoryboardUrl: string;
    activeStoryObject: string;
}

export interface StoryboardHeaderProps {
    storyObject?: StoryObjectDetails;
    storyboard?: Storyboard;
    story?: Story;
} 